
    import { Component } from 'vue-property-decorator';
    import CusDatePicker from '@/components/controls/cus-date-picker.vue';
    import VWidget from '@/components/VWidget.vue';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';
    import ChartOperation from './chart-operation.vue';
    import ChartTickets from './chart-tickets.vue';
    import Widgets from './widgets.vue';
    import DealerMap from '@/views/admin/dealer/map.vue';
    import CasisDealerMultiFilter from '@/views/casis/dealer-multi-filter.vue';
    import CasisManufacturerMultiFilter from '@/views/casis/manufacturer-multi-filter.vue';

    @Component({
        components: { CusDatePicker, VWidget, ChartOperation, Widgets, DealerMap, ChartTickets, CasisDealerMultiFilter, CasisManufacturerMultiFilter },
        data() {
            return {
            }
        },
    })

    export default class HomeView extends ListBase {
        loadingA: boolean = false;
        selectedDealerIds: number[] = [];
        selectedManufacturerIds: number[] = [];

        get isDealer() {
            return Util.abp.session.isDealer();
        }

        get loading() {
            return this.$store.state.dashboard.loading;
        }

        get loadingDealers() {
            return this.$store.state.dealer.loading;
        }

        get dashActivity() {
            return this.$store.state.dashboard.activity;
        }

        formatPrice(price) {
            let sign = Util.abp.setting.get('DEFAULT_CURRENCY_SIGN');
            return sign + ' ' + Math.round(price);
        }

        async loadActivities() {
            this.loadingA = true;
            await this.$store.dispatch({
                type: 'dashboard/getDashActivity'
            });
            this.loadingA = false;
        }

        async loadDealers() {
            await this.$store.dispatch({ type: 'dealer/getAllActive' });
            setTimeout(() => {
                if (this.$refs.map != undefined)
                    (this.$refs.map as any).init();
            }, 100);
        }

        async mounted() {
            await Promise.all([
                this.$store.dispatch({ type: 'dealer/getAllActive' }),
                this.$store.dispatch({ type: 'manufacturer/getAllActive' }),
            ]);

            const sessionDealer = Number(Util.abp.session.dealerId);
            this.selectedDealerIds = this.isDealer && sessionDealer > 0
                ? [sessionDealer]
                : this.$store.state.dealer.activeList.map((item: any) => item.id);
            this.selectedManufacturerIds = this.$store.state.manufacturer.activeList.map((item: any) => item.id);
        }

        async created() {

        }
    }
